import { computed } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { queryKeys } from '../queryKeys';

import { accountClusters } from '@/api/routes/clusters';
import apiClient from '@/modules/ApiClient';
import { useAccountsService } from '@/modules/Accounts/services/AccountsService';

type ClusterListItem = {
  id: string;
  name: string;
  [key: string]: unknown;
};

type ClustersListResponse = {
  data?: ClusterListItem[];
};

export function useClustersListQuery() {
  const accountsService = useAccountsService();
  const accountId = computed(() => accountsService.account?.id ?? '');

  return useQuery({
    queryKey: computed(() => queryKeys.clusters.list(accountId.value)),
    queryFn: async () => {
      const { data } = await apiClient.request<ClustersListResponse>({
        method: 'GET',
        url: accountClusters,
        pathParams: {
          account: accountId.value,
        },
        params: {
          per_page: 1000,
          page_num: 1,
          filters: [
            {
              field: 'name',
              operator: 'like',
              value: '',
            },
          ],
        },
      });

      return data?.data ?? [];
    },
    enabled: computed(() => Boolean(accountId.value)),
    ...ENTITY_LIST_QUERY_OPTIONS,
  });
}
